import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import './App.css';
//import ConstellationBackground from './components/ConstellationBackground';
import HeroSection from './components/HeroSection';
import FeaturedProjectsSection from './components/FeaturedProjectsSection';
import NotableProjectsSection from './components/NotableProjectsSection';
import TopProjectSection from './components/TopProjectSection';
import SkillsSection from './components/SkillsSection';
import ExperienceSection from './components/ExperienceSection';
import EducationSection from './components/EducationSection';
import CommunitySection from './components/CommunitySection';

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    ReactGA.initialize('GTM-MX636X4M');
    ReactGA.send({ hitType: 'pageview', page: '/', title: 'Tyler The Dev' });
    setIsLoaded(true);
  }, []);

  return (
    <div className={`modern-portfolio ${isLoaded ? 'loaded' : ''}`}>
      <div style={{position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: -1}}></div> {/* <ConstellationBackground particleCount={150} /> */}
      <HeroSection />
      <TopProjectSection />
      <FeaturedProjectsSection />
      <NotableProjectsSection />
      <SkillsSection />
      <ExperienceSection />
      <EducationSection />
      <CommunitySection />
    </div>
  );
}

export default App;
